import { useQuery } from '@tanstack/react-query';
import { billingApi } from '../../api/endpoints';
import { useI18n } from '../../i18n';

// Whether DoCuLat takes payments yet (TF-402, docs/adr/0240-payments-off.md). One source, billing's public
// settings, so the notices go by themselves when a provider is connected. Not known yet: nothing is said.

export function usePaymentsOff(): boolean {
  const settings = useQuery({ queryKey: ['billing-public-settings'], queryFn: () => billingApi.publicSettings(), staleTime: 5 * 60_000 });
  return settings.data?.paymentsActive === false;
}

/** "Payments are not switched on yet. Every plan is free of charge until then." Inline: within a sentence's paragraph. */
export function PaymentsNotice({ inline = false }: { inline?: boolean }) {
  const { t } = useI18n();
  if (!usePaymentsOff()) return null;
  return inline ? <span className="payments-notice"> {t('payments.short')}</span> : <p className="hint payments-notice">{t('payments.short')}</p>;
}

/** What it means, in full: at the top of Plan and billing. */
export function PaymentsNoticeLong() {
  const { t } = useI18n();
  return usePaymentsOff() ? <p className="banner banner-info payments-notice-long">{t('payments.long')}</p> : null;
}
